import {
	Log,
	Warn,
	Error
} from './message-console';
export const initMessage = function(project) {
	//define Log and Warn
	Object.defineProperty(project, 'log', {
		value: Log,
		writable: process.env.NODE_ENV !== 'production'
	});
	Object.defineProperty(project, 'warn', {
		value: Warn,
		writable: process.env.NODE_ENV !== 'production'
	});
	Object.defineProperty(project, 'error', {
		value: Error,
		writable: process.env.NODE_ENV !== 'production'
	});
}
